import styled, {css} from 'styled-components';

import type {Variant} from '../ToolBoxButton/types';
import type {Size} from './types';

import {
  getAlphaColor,
  getColor,
  gts,
  ms,
  square,
  type ThemeAndAnyColor,
} from '../../styles';
import {Clickable} from '../../uikit/Clickable';
import {View} from '../../uikit/View';

const getBackgroundColor = (variant: Variant): ThemeAndAnyColor => {
  switch (variant) {
    case 'food_diary':
      return '#7ECBB6';
    case 'trackers':
      return 'static.accent.trackers';
    default:
      return 'background.white';
  }
};

export const Container = styled(View)<{
  isClickable: boolean;
  size: Size;
  variant: Variant;
}>`
  align-items: center;
  background-color: ${p => getColor(getBackgroundColor(p.variant))(p)};
  border-radius: ${gts('borderRadius.la')};
  padding-block: ${gts('padding.xl')};
  padding-inline: ${gts('padding.xxxl')};
  gap: ${gts('gap.me')};

  ${p => {
    switch (p.size) {
      case 'me':
        return css`
          flex: 1;
        `;
      case 'sm':
        return css`
          width: ${ms(300)};
        `;
    }
  }};

  ${p =>
    p.isClickable &&
    css`
      cursor: pointer;
    `}
`;

export const Content = styled(View)`
  flex: 1;
  flex-direction: column;
  gap: ${gts('gap.xs')};
`;

export const BannerButton = styled(Clickable)`
  display: flex;
  border-radius: ${ms(15)};
  background-color: ${getAlphaColor('background.white', 0.4)};
  justify-content: center;
  align-items: center;
  ${square(30)}
`;
